export const FETCH_LIST = 'expenses/list';
export const FETCH_LIST_SUCCESS = 'expenses/list_success';
export const FETCH_LIST_FAILED = 'expenses/list_failed';

export const FETCH_DETAILS = 'expenses/details';
export const FETCH_DETAILS_SUCCESS = 'expenses/details_success';

export const FETCH_DETAILS_FAILED = 'expenses/details_failed';

export const CREATE = 'expenses/create';
export const CREATE_SUCCESS = 'expenses/create_success';
export const CREATE_FAILED = 'expenses/create_failed';

export const UPDATE = 'expenses/update';
export const UPDATE_SUCCESS = 'expenses/update_success';
export const UPDATE_FAILED = 'expenses/update_failed';

export const DELETE = 'expenses/delete';
export const DELETE_SUCCESS = 'expenses/delete_success';
export const DELETE_FAILED = 'expenses/delete_failed';

export const BULK = 'expenses/bulk';
export const BULK_SUCCESS = 'expenses/bulk_success';
export const BULK_FAILED = 'expenses/bulk_failed';

export const CLEAR_DATA = 'units/clear_data';

export type UnitsAction =
  | typeof FETCH_DETAILS
  | typeof FETCH_DETAILS_FAILED
  | typeof FETCH_DETAILS_SUCCESS
  | typeof FETCH_LIST
  | typeof FETCH_LIST_FAILED
  | typeof FETCH_LIST_SUCCESS
  | typeof CREATE
  | typeof CREATE_FAILED
  | typeof CREATE_SUCCESS
  | typeof UPDATE
  | typeof UPDATE_FAILED
  | typeof UPDATE_SUCCESS
  | typeof DELETE
  | typeof DELETE_FAILED
  | typeof DELETE_SUCCESS
  | typeof BULK
  | typeof BULK_FAILED
  | typeof BULK_SUCCESS
  | typeof CLEAR_DATA;
